import PropTypes from 'prop-types';
import { PICKUP, DROPBOX, SHOP_ONLINE } from './constants';
import addressPropTypes from '@app/components/common/address/address.proptypes';

const valueLabel = PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string
});

export const activeTab = PropTypes.oneOf([PICKUP, SHOP_ONLINE]);

export const addresses = addressPropTypes.addresses;

export const addressLimit = PropTypes.string;
export const espot = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);

export const country = PropTypes.shape({
  code: PropTypes.string,
  displayName: PropTypes.string,
  states: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      displayName: PropTypes.string
    })
  )
});

export const countries = PropTypes.arrayOf(country);

export const defaultCountry = PropTypes.string;

export const requiredFields = PropTypes.arrayOf(PropTypes.string);

export const defaultFulfillmentOption = PropTypes.oneOf([
  SHOP_ONLINE,
  PICKUP,
  DROPBOX
]);

export const setErrors = PropTypes.func.isRequired;

export const isCSPCustomer = PropTypes.bool.isRequired;
export const espotObject = PropTypes.shape({
  html: PropTypes.string
});
export const isPageLoading = PropTypes.bool;
export const isGuess = PropTypes.bool;
export const BMPoland = PropTypes.string;
export const saveAddress = PropTypes.func.isRequired;

export const locale = PropTypes.string;

export const userType = PropTypes.string.isRequired;

export const fulfillmentOptions = {
  [PICKUP]: PropTypes.shape({
    storeInfo: PropTypes.shape({
      storeHours: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string
        })
      ),
      phone: PropTypes.string
    }),
    address: addresses,
    methods: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string,
        default: PropTypes.bool
      })
    ),
    instructions: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string,
        default: PropTypes.bool
      })
    ),
    shipModeId: PropTypes.string,
    physicalStoreId: PropTypes.string
  }),
  [SHOP_ONLINE]: PropTypes.shape({
    address: addresses,
    methods: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string,
        default: PropTypes.bool
      })
    ),
    instructions: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string,
        default: PropTypes.bool
      })
    ),
    shipModeId: PropTypes.string,
    showInlineAddressForm: PropTypes.bool
  }),
  [DROPBOX]: PropTypes.shape({
    label: PropTypes.string,
    uom: PropTypes.string,
    address: addresses,
    methods: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string,
        default: PropTypes.bool
      })
    ),
    instructions: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string,
        default: PropTypes.bool
      })
    )
  })
};

const availability = PropTypes.arrayOf(
  PropTypes.shape({
    availabilityMessage: PropTypes.string,
    quantityAvailable: PropTypes.string
  })
);

const lineItemNotes = PropTypes.shape({
  customerPartNumber: PropTypes.string,
  customerSerialNumber: PropTypes.string,
  lineItemNo: PropTypes.string,
  partNote: PropTypes.string
});

const orderItems = PropTypes.arrayOf(
  PropTypes.shape({
    availability,
    coreDeposit: PropTypes.string,
    imageURL: PropTypes.string,
    name: PropTypes.string,
    orderItemExtendAttribute: PropTypes.shape({
      lineItemNotes,
      nonReturnablePartNumber: PropTypes.bool,
      remanPartNumber: PropTypes.bool,
      ssroBundle: PropTypes.arrayOf(
        PropTypes.shape({
          selfServiceOptionId: PropTypes.string,
          selfServiceOptionName: PropTypes.string
        })
      )
    }),
    orderItemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalPrice: PropTypes.string,
    unitPrice: PropTypes.string
  })
);

const orderExtendAttribute = PropTypes.shape({
  orderByEmail: PropTypes.string,
  orderByName: PropTypes.string,
  orderByPhone: PropTypes.string
});

const orderTotals = PropTypes.shape({
  orderAdjustment: PropTypes.string,
  orderSubTotal: PropTypes.string,
  orderTotal: PropTypes.string,
  shipping: PropTypes.string,
  taxLabel: PropTypes.arrayOf(valueLabel),
  totaltax: PropTypes.string
});

const orderInformation = PropTypes.shape({
  orderExtendAttribute,
  orderItem: orderItems,
  orderStatus: PropTypes.string,
  orderTotals
});

const requestByDate = PropTypes.shape({
  format: PropTypes.string,
  value: PropTypes.string,
  cutOffTimes: PropTypes.shape({
    [DROPBOX]: PropTypes.string,
    [PICKUP]: PropTypes.string,
    [SHOP_ONLINE]: PropTypes.string
  })
});

export const storeHoursPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    currentDay: PropTypes.string
  })
);

const pickupAndDeliveryProps = {
  activeTab,
  addresses,
  addressLimit,
  availability,
  BMPoland,
  country,
  countries,
  defaultCountry,
  defaultFulfillmentOption,
  espot,
  fulfillmentOptions,
  isCSPCustomer,
  isPageLoading,
  lineItemNotes,
  locale,
  orderInformation,
  orderItems,
  requestByDate,
  requiredFields,
  saveAddress,
  setErrors,
  userType,
  isGuess
};

export default pickupAndDeliveryProps;
